import { observer } from 'mobx-react-lite';
import { twMerge } from 'tailwind-merge';

export type PeriodType = '1D' | '1W' | '1M' | '3M' | 'YTD' | 'ALL';

interface PeriodFilterTabsProps {
    selectedPeriod: PeriodType;
    onPeriodChange: (period: PeriodType) => void;
}

const PeriodFilterTabs = observer(({ selectedPeriod, onPeriodChange }: PeriodFilterTabsProps) => {
    const periods: PeriodType[] = ['1D', '1W', '1M', '3M', 'YTD', 'ALL'];

    return (
        <div className="tabs tabs-boxed w-full justify-between gap-0.5 p-1">
            {periods.map((period) => (
                <button
                    key={period}
                    className={twMerge(
                        'tab flex-1 text-xs font-semibold',
                        selectedPeriod === period && 'tab-active',
                    )}
                    onClick={() => onPeriodChange(period)}
                >
                    {period}
                </button>
            ))}
        </div>
    );
});

export default PeriodFilterTabs;
